import React from "react";

import { translate } from "sulu-admin-bundle/utils";
import shirt from "../../../svgs/Shirt";

const FooterRow = ({ noOfSelectedPlayer, minPlayers, maxPlayers }) => {
    const blackShirtLabel = translate("sulu_admin.match.legend.black_shirt");
    const whiteShirtLabel = translate("sulu_admin.match.legend.white_shirt");

    const warningMessage =
        noOfSelectedPlayer < minPlayers
            ? translate("sulu_admin.match.player_min", {
                  number: minPlayers - noOfSelectedPlayer,
              })
            : noOfSelectedPlayer > maxPlayers
            ? translate("sulu_admin.match.player_max", {
                  number: noOfSelectedPlayer - maxPlayers,
              })
            : "";

    const numberColor = {
        color:
            noOfSelectedPlayer < minPlayers
                ? "red"
                : noOfSelectedPlayer > maxPlayers
                ? "red"
                : "green",
    };

    return (
        <>
            <div
                style={{
                    backgroundColor: "#E5E5E5",
                    fontSize: "16px",
                    padding: "10px 20px",
                    border: "1px solid #DDDDDD",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                }}
            >
                Spieler gesamt {noOfSelectedPlayer}
                <strong style={numberColor}>
                    ({minPlayers}
                    {` - ${maxPlayers}`})
                </strong>
                {warningMessage && (
                    <div
                        style={{
                            color: "red",
                            fontSize: "12px",
                        }}
                    >
                        {warningMessage}
                    </div>
                )}
            </div>

            <div>
                <div style={{ margin: "10px", marginLeft: "100px" }}>
                    <p>
                        {shirt({ fill: "black" })} {blackShirtLabel}
                    </p>
                    <p>
                        {shirt({ fill: "white", stroke: "black" })}{" "}
                        {whiteShirtLabel}
                    </p>
                </div>
            </div>
        </>
    );
};

export default FooterRow;
